import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import UserService from '../utils/UserService';

const PROMPT_DISMISS_DURATION = 60 * 60 * 1000 * 24 * 30; // 30 days in milliseconds

export const useTermsheetNotification = () => {
  const [shouldShowNotification, setShouldShowNotification] = useState(false);
  const location = useLocation();
  const isDealFlowPage = location.pathname === '/deal-flow';
  const userInfo = useSelector((state) => state?.user?.userInfo);

  useEffect(() => {
    const checkPromptVisibility = () => {
      // Only show for founders who haven't set a time slot
      const isDismissed = UserService.getTermsheetNotificationDismissed();

      if (isDismissed) {
        setShouldShowNotification(false);
        return;
      }

      if (userInfo?.userTypeId === 1 && !userInfo?.hasDeal && !isDealFlowPage) {
        const lastSnoozed = UserService.getTermsheetNotificationSnoozed();

        if (!lastSnoozed) {
          setShouldShowNotification(true);
        } else {
          const timeSinceLastDismissed = Date.now() - parseInt(lastSnoozed);

          if (timeSinceLastDismissed >= PROMPT_DISMISS_DURATION) {
            setShouldShowNotification(true);
          }
        }
      } else {
        setShouldShowNotification(false);
      }
    };

    checkPromptVisibility();
  }, [userInfo, location.pathname]);

  return {
    shouldShowNotification,
    setShouldShowNotification,
  };
};
